import React from "react";
import ReactMarkdown from "react-markdown";
import { graphql } from "gatsby";

import Layout from '../components/Layout';
import CaseStudyItem from '../components/Case-Study-Item';
import Title from '../components/Title';

const CaseStudiesPage = ({data}) => {
  const pageData = data.strapiOurWork;
  const {About: aboutData} = pageData;
  const studies = data.allStrapiCaseStudy.nodes;

  return (
    <Layout title={pageData.Title}>
      <Title>{pageData.Title}</Title>

      {
        aboutData && (
          <div className="py-8 bg-white">
            <div className="container mx-auto px-12">
              <h2 className="text-xl font-bold mb-3">{aboutData.Title}</h2>
              <div className="prose max-w-none">
                <ReactMarkdown children={aboutData.Content} />
              </div>
            </div>
          </div>
        )
      }

      {
        pageData.ShowCaseStudies && (
          <>
            <div className="container mx-auto py-8 px-12 grid grid-cols-12 gap-4">
              <h3 className="col-span-12 text-xl font-bold">People's experiences with Warm Homes Essex</h3>
              <div className="col-span-12">
                {studies.map(study => (
                  <CaseStudyItem
                    key={study.Slug}
                    content={study.Snippet}
                    coverImage={study.Image}
                    title={study.Title}
                    url={`/case-study/${study.Slug}`}
                  />
                ))}
              </div>
            </div>
          </>
        )
      }
    </Layout>
  );
}

export const query = graphql`
  query OurWorkQuery {
    strapiOurWork {
      Title
      ShowCaseStudies
      About {
        Title
        Content
      }
    }
    allStrapiCaseStudy(sort: {fields: updated_at, order: ASC}) {
      nodes {
        Slug
        Title
        Snippet
        Image {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(aspectRatio: 1.8)
            }
          }
        }
      }
    }
  }
`;

export default CaseStudiesPage
